import Base from '../../pages/Base'
import Consent from '../../components/Consent'

export const ConsentPage = ({ metadata, csrf, brandingSettings }) => (
  <Base brandingSettings={brandingSettings} showReturnButton={false}>
    <Consent {...metadata} csrf={csrf} brandingSettings={brandingSettings} />
  </Base>
)

export default ConsentPage
